import { styled } from "../../../styles";

export const RowActions = styled("div", {
  display: "flex",
  gap: "8px",
  justifyContent: "flex-end",
});

/** Caption above a drill-down table, e.g. the group's sync cursor. */
export const DrillDownCaption = styled("p", {
  margin: "0 0 12px",
  fontFamily: "$openSans",
  fontSize: "13px",
  color: "$gray-80",
});

export const PayloadContainer = styled("pre", {
  backgroundColor: "$gray-20",
  padding: "12px",
  borderRadius: "6px",
  fontSize: "12px",
  fontFamily: "monospace",
  overflow: "auto",
  maxHeight: "50vh",
  whiteSpace: "pre-wrap",
  wordBreak: "break-word",
  margin: 0,
});

/** The last delivery error, shown above the payload when a message failed. */
export const MessageErrorNotice = styled("p", {
  margin: "0 0 12px",
  padding: "12px",
  borderRadius: "6px",
  backgroundColor: "$error-lightest",
  color: "$error-dark",
  fontFamily: "$openSans",
  fontSize: "13px",
  whiteSpace: "pre-wrap",
  wordBreak: "break-word",
});
